import PrivacyComponent from "@/features/privacy-page/components/PrivacyPage";
import React from "react";

export const PrivacyPage = () => {
  return (
    <div>
      <PrivacyComponent />
    </div>
  );
};
